function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M12.506 6.632c3.137 0 5.684 2.593 5.684 5.79a5.71 5.71 0 01-.41 2.118l3.32 3.381a13.676 13.676 0 003.9-5.5c-1.967-5.083-6.821-8.684-12.506-8.684-1.591 0-3.115.29-4.524.81l2.455 2.501a5.43 5.43 0 012.08-.416zM1.136 3.47L3.73 6.11l.523.532A13.648 13.648 0 000 12.421c1.967 5.083 6.821 8.684 12.506 8.684 1.762 0 3.444-.347 4.98-.972l.477.486L21.293 24l1.445-1.47L2.58 2 1.137 3.47zm6.288 6.403l1.762 1.794a3.324 3.324 0 00-.091.753c0 1.922 1.523 3.474 3.41 3.474.25 0 .5-.035.74-.093l1.762 1.795a5.552 5.552 0 01-2.501.614c-3.138 0-5.685-2.594-5.685-5.79 0-.915.228-1.772.603-2.547zm4.9-.903l3.581 3.647.023-.185c0-1.922-1.524-3.474-3.41-3.474l-.194.012z"
});

function SvgVisibilityHide(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 25 25"
  }, props), _ref);
}

export default SvgVisibilityHide;